import { useEffect, useRef } from 'react'
import { motion, useMotionValue, useSpring } from 'framer-motion'

export default function MagneticCursor() {
  const cursorX = useMotionValue(0)
  const cursorY = useMotionValue(0)
  // Optimized spring config for smoother, more responsive movement
  const springConfig = { damping: 25, stiffness: 700, mass: 0.1 }
  const cursorXSpring = useSpring(cursorX, springConfig)
  const cursorYSpring = useSpring(cursorY, springConfig)
  const rafRef = useRef<number>()

  useEffect(() => {
    // Hide native cursor on desktop only
    if (window.matchMedia('(pointer: fine)').matches) {
      const style = document.createElement('style')
      style.textContent = `
        * {
          cursor: none !important;
        }
      `
      document.head.appendChild(style)
      
      // Use requestAnimationFrame for smoother updates
      const updateCursor = (e: MouseEvent) => {
        if (rafRef.current) {
          cancelAnimationFrame(rafRef.current)
        }
        
        rafRef.current = requestAnimationFrame(() => {
          cursorX.set(e.clientX)
          cursorY.set(e.clientY)
        })
      }

      window.addEventListener('mousemove', updateCursor, { passive: true })

      return () => {
        if (rafRef.current) {
          cancelAnimationFrame(rafRef.current)
        }
        document.head.removeChild(style)
        window.removeEventListener('mousemove', updateCursor)
      }
    }
  }, [cursorX, cursorY])

  return (
    <motion.div
      className="fixed top-0 left-0 pointer-events-none z-[9999] will-change-transform"
      style={{
        x: cursorXSpring,
        y: cursorYSpring,
      }}
    >
      {/* Simple cursor dot - no hover effects */}
      <motion.div
        className="w-2 h-2 rounded-full bg-accent -translate-x-1/2 -translate-y-1/2"
      />
    </motion.div>
  )
}
